import React, { useState } from 'react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Loader2, X, Plus } from 'lucide-react';

export const WizardStepClasses = ({ classes, setClasses, onNext, onBack, loading }) => {
    const [manualClass, setManualClass] = useState('');

    const toggleClass = (c) => {
        if (classes.includes(c)) {
            setClasses(prev => prev.filter(item => item !== c));
        } else {
            setClasses(prev => [...prev, c].sort((a, b) => a - b));
        }
    };

    const addManual = () => {
        const num = parseInt(manualClass, 10);
        if (num >= 1 && num <= 45 && !classes.includes(num)) {
            setClasses(prev => [...prev, num].sort((a, b) => a - b));
        }
        setManualClass(''); // clear
    };

    return (
        <div className="space-y-6">
            <div className="mb-4">
                <p className="text-sm font-medium text-gray-700 mb-2">Sugerencias del Sistema</p>
                {classes.length === 0 ? (
                    <div className="bg-yellow-50 text-yellow-800 p-4 rounded-md border border-yellow-200 text-sm">
                        No se encontraron sugerencias específicas para esta descripción. Por favor, agregue manualmente las clases deseadas (1-45).
                    </div>
                ) : (
                    <div className="flex flex-wrap gap-2">
                        {classes.map(c => (
                            <div
                                key={c}
                                className="inline-flex items-center gap-2 bg-indigo-50 border border-indigo-200 text-indigo-700 px-3 py-1.5 rounded-full text-sm font-semibold transition"
                            >
                                Clase {c}
                                <button
                                    onClick={() => toggleClass(c)}
                                    className="hover:bg-indigo-200 rounded-full p-0.5 transition"
                                    aria-label="Remove"
                                >
                                    <X className="h-3 w-3" />
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                <p className="text-sm font-medium text-gray-700 mb-2">Añadir otra clase manual (1-45)</p>
                <div className="flex items-center gap-2">
                    <input
                        type="number"
                        min="1"
                        max="45"
                        value={manualClass}
                        onChange={(e) => setManualClass(e.target.value)}
                        placeholder="Ej: 30"
                        className="px-4 py-2 bg-white border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 w-32"
                    />
                    <Button
                        type="button"
                        variant="secondary"
                        onClick={addManual}
                        disabled={!manualClass}
                        className="bg-white border hover:bg-gray-100 text-gray-700"
                    >
                        <Plus className="h-4 w-4 mr-2" />
                        Agregar
                    </Button>
                </div>
            </div>

            <div className="pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
                <Button
                    variant="outline"
                    onClick={onBack}
                    disabled={loading}
                    className="w-full md:w-auto"
                >
                    Retroceder
                </Button>
                <Button
                    onClick={onNext}
                    disabled={loading || classes.length === 0}
                    className="w-full md:w-auto bg-indigo-600 hover:bg-indigo-700 text-white min-w-[120px]"
                >
                    {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
                    {loading ? 'Preparando...' : 'Siguiente Paso'}
                </Button>
            </div>
        </div>
    );
};
